<div class="sticky-top" *ngIf="ready">

  <nav class="navbar navbar-expand-md navbar-light bg-light">

    <div class="d-flex container flex-row">

      <!-- Icon -->
      <div class="order-2">
        <div class="dropdown d-inline-block mr-3">
          <a class="dropdown-toggle" role="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
            <img class="mr-2" src="{{userPicture}}" alt="user-icon" height="30px" width="30px"> {{currentUser.firstName}} {{currentUser.lastName}}
          </a>
          <div class="dropdown-menu" aria-labelledby="navbarDropdown">
            <a title="login" class="dropdown-item" (click)="logout()">Logout</a>
          </div>
        </div>
        <a class="navbar-brand mr-0 ml-1" routerLink=''>
          <img src="../../../assets/edtell_logo_smallest.png" alt="edtell-logo" height="30" width="75">
        </a>
      </div>

      <!-- Hide Nav Bar-->
      <button class="navbar-toggler order-1" type="button" data-toggle="collapse" data-target="#navbarSupportedContent" aria-controls="navbarSupportedContent"
        aria-expanded="false" aria-label="Toggle navigation">
        <span class="navbar-toggler-icon"></span>
      </button>

      <!-- Nav Bar Links -->
      <div class="collapse navbar-collapse order-3 order-md-1" id="navbarSupportedContent">
        <ul class="navbar-nav mr-auto">

          <li class="nav-item">
            <a class="nav-link pl-0" id="homeNav" title="Home" routerLink="/">Home </a>
          </li>

          <li class="nav-item" *ngFor="let n of navData; index as i">
            <app-navigation-link [navElm]="n" [index]="i"></app-navigation-link>
          </li>

        </ul>
      </div>
    </div>
  </nav>

</div>
